<div class="row my-1 justify-content-between">
    <div class="col-12 col-lg-4 d-flex flex-column justify-content-around">
        <div class="row">
            <div class="col-auto pe-0">
                <strong class="user-select-auto">{{ header().weekday }} {{ header().startDateTime }}</strong>
                @if (header().isMultiDay) {
                    <span> -<br /></span>
                }
                <strong class="user-select-auto">{{ header().endDateTime }}</strong>
                @if (header().canChangeDuration) {
                    <a class="cursor-pointer" (click)="actionSelect.emit('duration')">
                        <fa-icon [icon]="faPencil" class="ms-1"></fa-icon>
                    </a>
                }
            </div>
            <div class="col d-lg-none d-block ps-0">
                <pace-status-badge [badge]="header().badge" [showUnreadIcon]="false"></pace-status-badge>
            </div>
        </div>
        <div class="row">
            <div class="col mt-1 mt-lg-0">
                <span
                    ><a
                        class="cursor-pointer user-select-auto"
                        role="button"
                        [attr.aria-label]="header().customerAriaLabel"
                        (click)="actionSelect.emit('customer')"
                        >{{ header().customerName }}</a
                    ></span
                >
            </div>
        </div>
        <div class="row">
            <div class="col mt-1 mt-lg-0">
                <span class="user-select-auto">{{ header().notificationType }}</span>
                @if (header().isRemoteSupport) {
                    <fa-icon [icon]="faPhone" size="lg" class="ps-2"></fa-icon>
                }
            </div>
        </div>
        @if (header().clarifyTextHtml) {
            <div class="row">
                <div class="col mt-1 mt-lg-0">
                    <span class="user-select-auto" [innerHTML]="header().clarifyTextHtml"></span>
                </div>
            </div>
        }
        @if (header().marketMapLabel) {
            <div class="row">
                <div class="col mt-1 mt-lg-0">
                    <span
                        ><a
                            class="cursor-pointer user-select-auto"
                            role="button"
                            [attr.aria-label]="header().marketMapAriaLabel"
                            (click)="actionSelect.emit('marketMap')"
                            >{{ header().marketMapLabel }}</a
                        ></span
                    >
                </div>
            </div>
        }
    </div>
    <div class="col-12 col-lg-4 mt-3 mt-lg-0 ms-auto">
        @for (field of header().fields; track field.id) {
            <div class="row mb-1 mb-lg-0">
                @if (field.label) {
                    <strong class="col-3" [class]="field.labelClass">{{ field.label }}</strong>
                }
                <div class="col-9">
                    <span class="notification-detail-text user-select-auto mb-0" [class]="field.valueClass">{{
                        field.value
                    }}</span>
                    @if (field.additionalValue) {
                        <span> &nbsp;- <br /></span>
                        <span class="notification-detail-text user-select-auto mb-0" [class]="field.valueClass">{{
                            field.additionalValue
                        }}</span>
                    }
                    @if (field.serialNumber) {
                        <span class="serial-no user-select-auto">{{ field.serialNumber }}</span>
                    }
                    @if (field.showMissingIcon) {
                        <fa-icon [icon]="faBan" class="ms-1"></fa-icon>
                    }
                    @if (field.counter !== undefined) {
                        <span
                            class="internal-info ms-1"
                            role="button"
                            [attr.aria-label]="field.counterAriaLabel"
                            (click)="fieldActionSelect.emit(field)"
                        >
                            <fa-icon [icon]="faNewspaper"></fa-icon>&nbsp;
                            <span class="badge rounded-pill bg-primary d-inline">{{ field.counter }}</span>
                        </span>
                    }
                    @if (field.action !== 'none') {
                        <a class="cursor-pointer" (click)="fieldActionSelect.emit(field)">
                            <fa-icon [icon]="field.action === 'edit' ? faPencil : faInfoCircle" class="ms-1"></fa-icon>
                        </a>
                    }
                </div>
            </div>
        }
    </div>
    <div class="col-5 col-lg-4 d-lg-flex flex-column justify-content-around">
        <ng-content></ng-content>
    </div>

    <div class="row my-1">
        <div class="col d-flex justify-content-end d-lg-none">
            @if (header().userStatus) {
                <fa-icon class="me-1" [icon]="faFlag"></fa-icon>
            }
            <span>{{ header().userStatus }}</span>
        </div>
    </div>
</div>
